import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UserRow } from "../api/user.type";
import FullScreenContainer from "../components/layout/full-screen-container";
import MedicalRecordsLayout from "../components/layout/medical-records-layout";
import { useLoadContacts } from "../hooks/useLoadContacts";
import { useUserDetails } from "../hooks/useUserDetails";

const MedicalRecordsPage = () => {
  const { userId } = useParams<{ userId?: string }>();

  const [user, setUser] = useState<UserRow | null>(null);

  const { userDetails } = useUserDetails();

  const { contacts, isLoading: contactsLoading } = useLoadContacts();

  useEffect(() => {
    if (userDetails && userId === userDetails.id) {
      setUser(userDetails);
    } else {
      const contact = contacts.find((c) => c.related_user_id === userId);

      if (contact) {
        const relatedUser = contact.related_user;
        if (relatedUser && relatedUser.id) {
          setUser(relatedUser as UserRow);
        }
      }
    }

    if (!userId && userDetails) {
      setUser(userDetails);
    }
  }, [userDetails, userId, contacts]);

  return (
    <FullScreenContainer className="py-8">
      <MedicalRecordsLayout
        user={user}
        contacts={contacts}
        contactsLoading={contactsLoading}
      />
    </FullScreenContainer>
  );
};

export default MedicalRecordsPage;
